import { Button, Dropdown } from "react-bootstrap";

export default function MobileSort({ table }) {
  return (
    <Dropdown>
      <Dropdown.Toggle
        as="span"
        style={{
          cursor: "pointer",
        }}
      >
        <Button variant="light" size="sm">
          Razvrsti {table.getState().sorting.length > 0 && "po:"}{" "}
          {table.getState().sorting.length > 0
            ? `${
                table
                  .getAllLeafColumns()
                  .find((c) => c.id === table.getState().sorting[0].id)
                  ?.columnDef.header || ""
              } ${table.getState().sorting[0].desc ? "↓" : "↑"}`
            : ""}{" "}
        </Button>
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          minWidth: "200px",
          padding: "0.5rem",
        }}
      >
        {table.getAllLeafColumns().map((column) => (
          <>
            <Dropdown.Item
              key={column.id}
              onClick={() =>
                table.setSorting((old) => [
                  {
                    id: column.id,
                    desc: old.find((d) => d.id === column.id)?.desc === false,
                  },
                ])
              }
            >
              {column.columnDef.header}{" "}
              {{
                asc: "↑",
                desc: "↓",
              }[
                table.getState().sorting.find((d) => d.id === column.id)
                  ?.desc ?? null
              ] ?? null}
            </Dropdown.Item>
          </>
        ))}
        <Dropdown.Divider />

        <Dropdown.Item onClick={() => table.setSorting([])}>
          Ponastavi
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
